import React from 'react';
import styled from 'styled-components';
import { linkedinFeatured } from '../../data/constants';
import FeaturedCard from '../Cards/FeaturedCard';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 60px 0px 80px 0px;
    
    @media (max-width: 960px) {
        padding: 40px 0px 60px 0px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 40px 0px;
    gap: 12px;
    
    @media (max-width: 960px) {
        flex-direction: column;
        padding: 20px 0px;
    }
`;

const Title = styled.div`
  font-family: 'Mosca Laroke', 'Playfair Display', 'Bodoni Moda', 'Cinzel', serif;
  font-size: 76px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 32px;
  letter-spacing: 0.5px;

  @media (max-width: 1400px) { font-size: 64px; }
  @media (max-width: 1200px) { font-size: 52px; }
  @media (max-width: 768px)  { font-size: 44px; }
`;

const FeaturedGrid = styled.div`
    width: 100%;
    max-width: 1200px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-top: 20px;
    
    @media (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }
    
    @media (max-width: 640px) {
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
    }
`;

const LinkedInButton = styled.a`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    margin-top: 30px;
    background: #0077B5;
    color: white;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    
    &:hover {
        transform: scale(1.05);
        box-shadow: rgba(0, 119, 181, 0.4) 0px 8px 24px;
    }
`;

const LinkedInFeatured = () => {
    return (
        <Container id="linkedin-featured">
            <Wrapper>
                <Title>FEATURED ON LINKEDIN</Title>
                <FeaturedGrid>
                    {linkedinFeatured.map((post) => (
                        <FeaturedCard key={post.id} post={post} />
                    ))}
                </FeaturedGrid>
                <LinkedInButton
                    href="https://www.linkedin.com/in/urvansh-shah/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View Full Profile on LinkedIn →
                </LinkedInButton>
            </Wrapper>
        </Container>
    );
};

export default LinkedInFeatured;
